import { MessageDescriptor } from 'react-intl';

import {
  EffectDiagnocoinAdjustmentReasonCode,
  Order,
} from 'protocol/api/billing_new/dto_order_new_pb';

import { i18n as billingI18n } from '@/entities/billing';

export type OrderDiagnocoinAdjustment = {
  amount: number;
  reason?: MessageDescriptor;
  comment?: string;
};

export const getOrderDiagnocoinAdjustment = (
  order?: Order,
): OrderDiagnocoinAdjustment | undefined => {
  const effect = order?.Effect?.Effect;

  if (effect?.case !== 'DiagnocoinAdjustment') {
    return undefined;
  }

  const { Amount, Reason, Comment } = effect.value;

  return {
    amount: Number(Amount),
    // A reason newer than this build has no label yet: show none, not a crash.
    reason:
      Reason !==
      EffectDiagnocoinAdjustmentReasonCode.EffectDiagnocoinAdjustmentReasonCode_InvalidValue
        ? billingI18n.diagnocoinAdjustmentReasonMessages[Reason]
        : undefined,
    comment: Comment || undefined,
  };
};
